import React from 'react';
import './Companies.css';
import { Grid, Card, CardContent,CardMedia, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import RSV from './utils/Workus/RSV.jpeg';
import JAI from './utils/Workus/JAI.jpeg';
import Vendhan from './utils/Workus/vendhan.jpeg';
import Dataprocess from './utils/Workus/Dataprocess.png';
import OnlineData from './utils/Workus/Dataentry.png';
import OfflineData from './utils/Workus/Offlineentry.png';
import Datamining from './utils/Workus/Datamin.png';
import Dataconver from './utils/Workus/Dataconver.png';
import Datacleans from './utils/Workus/Datacleans.png';
import Health from './utils/Workus/Medical.png';
import Survey from './utils/Workus/Survey.png';
import invoice from './utils/Workus/E-invoice.png';
import CRM from './utils/Workus/CRM.png';
import Legal from './utils/Workus/Legaldoc.png';
import Bookkepp from './utils/Workus/Bookkeeping.png';
import { keyframes } from '@emotion/react';
// import  {  useEffect , useRef} from "react";
import Footer from './main/footer';
import Navbar from '../components/Navbar';



const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const fadeZoomVariant = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      }
    }
  };

const companies = [
  {
    name: 'RSV Technologies',
    logo: RSV,
    address: '111B South Agasthiyarpuram,\nVickramasingapuram,\nPin: 627425',
    phone: '6381933622',
  },
  {
    name: 'Vendhan InfoTech',
    logo: Vendhan,
    address: 'No. 10G-11 V. O. C Nagar,\nOddanchatram ,\nPin: 624619',
    phone: '9488867887',
  },
  {
    name: 'Jaivijay Enterprises',
    logo: JAI,
    address: ' C-231 Nirala Nagar,\nLucknow,Uttarpradesh\nPin: 226020',
    phone: '6388107554',
  },
];
const services = [
    {
      title: "Online Data Entry",
      description: "We provide accurate and timely online data entry services by entering information directly into web-based platforms, CRMs, or databases. Our experts handle tasks like eCommerce product updates, order processing, and client record management with precision and confidentiality...",
      image: OnlineData,
    },
    {
      title: "Offline Data Entry",
      description: "Ideal for businesses with data stored offline or in non-digital formats, our offline data entry services include manual input of forms, survey results, directories, and documents into digital formats without requiring an internet connection...",
      image: OfflineData,
    },
    {
      title: "Data Processing",
      description: "Transform your raw data into structured, meaningful information. We help in sorting, classifying, summarizing, and analyzing large volumes of data so it’s ready for business intelligence, reporting, and decision-making...",
      image: Dataprocess,
    },
    {
      title: "Data Mining & Data Collection",
      description: "Our team collects and compiles relevant data from various sources—websites, documents, directories, and databases. We extract actionable insights, such as contact information, business data, and market trends to support your marketing or research needs...",
      image: Datamining,
    },
    {
      title: "Data Conversion Services",
      description: "Integrate your operations with accounting platforms for automated billing, expense tracking, taxation, and financial reporting—ensuring compliance and transparency...",
      image: Dataconver,
    },
    {
      title: "Data Cleansing & Validation",
      description: "Ensure your databases are free of errors, duplicates, and outdated information. Our data cleansing services help improve your data quality through standardization, verification, and validation to support better analytics and decision-making...",
      image: Datacleans,
    },
    {
        title: "Medical & Insurance Claims Data Entry",
        description: "HIPAA-compliant data entry for healthcare providers and insurance firms. We handle patient details, medical billing codes, claims processing, and healthcare forms with high accuracy and strict confidentiality....",
        image: Health,
      },
      {
        title: "Survey/Questionnaire Data Entry",
        description: "Whether it's paper-based or digital surveys, we compile and organize responses with attention to accuracy and formatting. We help you analyze trends and feedback from customers, employees, or research participants...",
        image: Survey,
      },
      {
        title: "Invoice & Bill Data Entry",
        description: "We streamline your accounts by digitizing invoices, bills, receipts, and other financial records. Our data entry ensures accuracy for further processing in accounting software, reducing manual workload and errors..",
        image: invoice,
      },
      {
        title: "CRM Data Entry",
        description: "Our specialists help you keep customer data up-to-date in platforms like Salesforce, Zoho, and HubSpot. We enter leads, contact details, interactions, and updates to ensure your sales and support teams have reliable data access...",
        image: CRM,
      },
      {
        title: "Legal Document Data Entry",
        description: "We help eCommerce stores and retailers upload and manage product data—descriptions, prices, images, SKUs, categories—on platforms like Shopify, Magento, Amazon, and more. Our services ensure uniformity and consistency across your catalog...",
        image: Legal,
      },
      {
        title: "Bookkeeping Data Entry",
        description: "We support accountants and finance teams by entering day-to-day financial transactions, bank statements, expense records, and payroll information into software like QuickBooks, Xero, or Tally....",
        image: Bookkepp,
      },

  ];

const RepresentedCompanies = () => {
   
  return (
    <>
    <Navbar/>
 <div>
   <Box
  sx={{
    background: 'linear-gradient(-45deg, rgb(46, 181, 41), rgb(155, 216, 192), rgb(194, 233, 184), rgb(194, 185, 195))',
    backgroundSize: '400% 400%',
    animation: `${gradientAnimation} 10s ease infinite`,
    marginBottom: 5,
    paddingBottom: '5rem',
    paddingTop: '5rem'
  }}
  >
  <Typography
    variant="h5"
    align="center"
    sx={{
      fontFamily: "'Archivo Black', sans-serif",
      fontWeight: 'bold',
      color: 'darkgreen'
    }}
    gutterBottom
  >
    Partner Companies
  </Typography>

  <Grid container spacing={4} justifyContent="center">
    {companies.map((company, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Card
          sx={{
            height: 280,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            p: 3,
            borderRadius: 3,
            boxShadow: 3,
          }}
        >
          <img
            src={company.logo}
            alt={`${company.name} Logo`}
            style={{
              width: 110,
              height: 110,
              objectFit: 'contain',
              marginBottom: 16
            }}
          />
          <CardContent sx={{ flexGrow: 1 }}>
            <Typography variant="h6" gutterBottom>
              {company.name}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ whiteSpace: 'pre-line' }}
            >
              {company.address}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              📞 {company.phone}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
</Box>

<Box sx={{ mt: 6, mb: 6, px: 2 }}>
  <Typography
    variant="h4"
    sx={{
      textAlign: 'center',
      fontFamily: "'Archivo Black', sans-serif",
      fontWeight: 'bold',
      color: 'darkgreen',
      mb: 4,
    }}
  >
    Services Offered
  </Typography>

  <Grid container spacing={4} justifyContent="center">
    {services.map((service, idx) => (
      <Grid
        key={service.id || idx}
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        display="flex"
        justifyContent="center"
      >
        <motion.div
          variants={fadeZoomVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          style={{ width: '100%' }}
        >
          <Card
            sx={{
              height: '100%',
              maxWidth: 300,
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#fff',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CardMedia
              component="img"
              image={service.image}
              alt={service.title}
              sx={{
                height: 180,
                objectFit: 'cover',
              }}
            />

            {/* Title outside of CardContent */}
            <Box sx={{ px: 2, pt: 2, minHeight: '60px' }}>
              <Typography
                variant="h6"
                sx={{
                  color: 'darkgreen',
                  fontWeight: 'bold',
                  fontFamily: 'monospace',
                  fontSize: '20px',
                  textAlign: 'center',
                }}
              >
                {service.title}
              </Typography>
            </Box>

            {/* Description */}
            <CardContent
              sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                minHeight: '140px',
              }}
            >
              <Typography
                sx={{
                  color: 'black',
                  textAlign: 'justify',
                  fontFamily: 'serif',
                  fontSize: '15px',
                }}
              >
                {service.description}
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      </Grid>
    ))}
  </Grid>
</Box>
    
   <Footer/>
</div>
</>
  );
};

export default RepresentedCompanies;
